import axios, { AxiosInstance, AxiosResponse } from "axios";
import { PredictionsAllResponse, PredictionsLatestResponse, AgentproductivityAllResponse } from "../../../@Types/DRO/ChurnApiResponse/PredictionListResponse";

export class PredictionListApi {
    public static api = new PredictionListApi();
    private instance: AxiosInstance;

    constructor() {
        this.instance = axios.create({
            baseURL: process.env.REACT_APP_CHURN_BASE_URL,
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    getToken() {
        return localStorage.getItem("token");
    }

    async getPredictionsLatest(): Promise<PredictionsLatestResponse[]> {
        try {
            const response: AxiosResponse<PredictionsLatestResponse[]> = await this.instance.get("/predictions-latest/", {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching predictions latest data", error);
            throw error;
        }
    }

    async getPredictionsAll(start_date: string, end_date: string, call_type?: string, type?: string, page?:number, find?:string, export_data?:boolean): Promise<PredictionsAllResponse> {
        try {
            const response: AxiosResponse<PredictionsAllResponse> = await this.instance.get("/predictions-all/", {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                params: {
                    start_date,
                    end_date,
                    call_type,
                    type,
                    page,
                    find,
                    export_data
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching predictions all data", error);
            throw error;
        }
    }
    async getAgentproductivityAll(start_date: string, end_date: string,): Promise<AgentproductivityAllResponse> {
        try {
            const response: AxiosResponse<AgentproductivityAllResponse> = await this.instance.get("/agent-productivity/", {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                params: {
                    start_date,
                    end_date,
            
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching predictions all data", error);
            throw error;
        }
    }
}